import LottieImport, { LottieComponentProps } from 'lottie-react'
import { ComponentType } from 'react'

const Lottie = ((LottieImport as unknown as { default?: ComponentType<LottieComponentProps> }).default ??
    LottieImport) as ComponentType<LottieComponentProps>

export const LottieWrapper = (props: LottieComponentProps) => {
    return <Lottie style={{ height: '100%' }} {...props} />
}
